module.exports = __webpack_public_path__ + "media/images/screenshot-ce89c72bd0e467d8a011f2b9f83ab6ac.png";